import { Component, Input } from '@angular/core';

@Component({
	selector: 'c-art-img',
	templateUrl:'art-img.component.html'
})

export class ArtImgComp{
	@Input() articulo : any = false;
	constructor(){}
}